import AssignSearchOption from './AssignSearchOption';

export default AssignSearchOption;
